import axios from "axios";
import { StreetLight, StreetLightPatch } from "../types/streetLight.types";
import { ResponseAPIWithPagination } from "../../../common/types/API.types";

const BACKEND_URL = process.env.REACT_APP_BACKEND_API_URL + "/api/v1";

export const getSingleStreetLight = async (id: string) => {
  return (await axios.get<StreetLight>(`${BACKEND_URL}/streetlights/${id}`))
    .data;
};

export const getAllStreetLights = async (planBTId: string) => {
  return (
    await axios.get<ResponseAPIWithPagination<StreetLight>>(
      `${BACKEND_URL}/planbt/${planBTId}/streetlights?orderByQuery=-str_light_updated_at`
    )
  ).data;
};

export const createNewStreetLight = async (streetLight: StreetLightPatch) => {
  return (
    await axios.post<StreetLight>(`${BACKEND_URL}/streetlights`, {...streetLight})
  ).data;
};

export const updateStreetLight = async (
  streetLightId: string,
  streetLight: StreetLightPatch
) => {
  return (
    await axios.put<StreetLight>(
      `${BACKEND_URL}/streetlights/${streetLightId}`,
      streetLight
    )
  ).data;
};

export const deleteStreetLight = async (id: string) => {
  return await axios.delete(`${BACKEND_URL}/streetlights/${id}`);
};

export const streetLightAPI = {
  getSingleStreetLight,
  getAllStreetLights,
  createNewStreetLight,
  updateStreetLight,
  deleteStreetLight,
};

export default streetLightAPI;
